import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, Typography, Box, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/styles';
import logo from 'dataModule/assets/img/HealthBeatsDialogLogo.svg';

const styles = () => ({
  dialogPaper: {
    minHeight: '600px',
    maxHeight: '600px',
    minWidth: '654px',
    maxWidth: '654px',
    borderRadius: '8px',
  },
  titleWrapper: {
    position: 'relative',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'white',
    borderBottom: '1px solid #E0E0E0',
    padding: '16px',
  },
  titleWrapperNoBorder: {
    position: 'relative',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'white',
    padding: '16px',
  },
  titleLogo: {
    display: 'flex',
    alignItems: 'center',
  },
  dialogLogo: {
    maxWidth: '40px',
  },
  dialogTitle: {
    color: '#212121',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '19px',
    letterSpacing: '0.15000000596046448px',
    marginLeft: '12px',
  },
  dialogCloseButton: {
    position: 'relative',
    left: '10px',
    color: 'black',
    maxHeight: '40px',
    maxWidth: '40px',
  },
  scrollableContent: {
    padding: '0px 0px 0px 12px',
    maxHeight: 'calc(90vh - 120px)',

    /* 1) Hide scrollbar by default */
    overflowY: 'auto',
    scrollbarWidth: 'none', // Firefox
    '-ms-overflow-style': 'none', // IE/Edge
    '&::-webkit-scrollbar': {
      // WebKit browsers
      width: 0,
      background: 'transparent',
    },

    /* 2) On hover, show a slim scrollbar */
    '&:hover': {
      '&::-webkit-scrollbar': {
        width: '3px',
      },
      scrollbarWidth: 'thin', // Firefox
      scrollbarColor: 'rgba(0,0,0,0.2) transparent',
    },

    /* 3) Style the thumb when visible */
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0)', // hidden initially
      borderRadius: '2px',
    },
    '&:hover::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.2)', // 80% opacity on hover
    },
  },
});

@withStyles(styles, { index: 1 })
export default class HBModalDialog extends React.PureComponent {
  static propTypes = {
    open: PropTypes.bool,
    toggleOpenDialog: PropTypes.func,
    title: PropTypes.string,
    height: PropTypes.string, // e.g. '600px' or '80vh'
    width: PropTypes.string,
    borderHeader: PropTypes.bool
  };

  static defaultProps = {
    height: '600px',
    width: '654px',
    borderHeader: true,
    footerHeader: true
  };

  render() {
    const { title = '', open, toggleOpenDialog, classes, height, width, borderHeader, footerHeader, children } = this.props;

    return (
      <React.Fragment>
        <Dialog
          open={open}
          onClose={toggleOpenDialog}
          aria-labelledby="form-dialog-title"
          // override the paper sizing dynamically
          PaperProps={{
            className: classes.dialogPaper,
            style: { minHeight: height, maxHeight: height, minWidth: width, maxWidth: width },
          }}
        >
          <Box className={borderHeader ? classes.titleWrapper : classes.titleWrapperNoBorder}>
            <div className={classes.titleLogo}>
              <img src={logo} className={classes.dialogLogo} />
              <Typography variant="body1" className={classes.dialogTitle}>
                {title}
              </Typography>
            </div>
            <IconButton aria-label="close" className={classes.dialogCloseButton} onClick={toggleOpenDialog}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent className={classes.scrollableContent}>{children}</DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
